'use client'

import HCaptcha from '@hcaptcha/react-hcaptcha'
import clsx from 'clsx'
import { useField } from 'formik'
import { FC, useEffect, useRef } from 'react'
import useTranslation from '../../../../lib/hooks/useTranslation'
import inputStyles from '../input/input.module.css'
import InputError from '../inputError'
import InputLabel from '../inputLabel'
import styles from './captcha.module.css'

interface Props {
    className?: string
    label?: string
    name: string
    required?: boolean
}

const Captcha: FC<Props> = props => {
    const { locale } = useTranslation()
    const [field, meta, helpers] = useField(props.name)
    const captchaRef = useRef<HCaptcha | null>(null)
    const sitekey = process.env.NEXT_PUBLIC_HCAPTCHA_SITEKEY ?? ''

    const invalid = meta.touched && meta.error

    // Handles captcha token and sets it in Formik field
    const onVerify = (token: string | null) => {
        helpers.setValue(token)
    }

    useEffect(() => {
        if (captchaRef.current && field.value === '') {
            // Reset the captcha when the field value is reset
            captchaRef.current.resetCaptcha()
        }
    }, [field.value])

    return (
        <div className={clsx(inputStyles.root, props.className)}>
            <label className={inputStyles.label}>
                {props.label && (
                    <InputLabel>
                        {props.label}
                        {props.required && <span> *</span>}
                    </InputLabel>
                )}

                <div className={clsx(invalid && styles.invalid)}>
                    <HCaptcha
                        ref={captchaRef}
                        languageOverride={locale}
                        onVerify={onVerify}
                        sitekey={sitekey}
                    />
                </div>
            </label>
            <InputError name={field.name} />
        </div>
    )
}

export default Captcha
